import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const getTrades = async (params = {}) => {
  const { page = 1, url: customUrl } = params;
  
  // Определяем конечный URL
  const url = customUrl ? customUrl : `${backendUrl}/api/polymarket/trades/?page=${page}`;
  
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении торговых операций: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка получения торговых операций:', error);
    throw error;
  }
};